import { useSelector } from "react-redux";
import CustomInput from "../../components/inputs/CustomInputs";
import { Box } from "@mui/system";
import CustomDialog from "../../components/layouts/common/CustomDialog";
import { Grid2, ListItem } from "@mui/material";
import GeoLocation from "../../components/inputs/Geolocation";
import AsyncDropDown from "../../components/inputs/AsyncDropDown";
import { getCountryApi } from "../../apis/country.api";
import { getStateApi } from "../../apis/state.api";
import { getCityApi } from "../../apis/city.api";

const UpdateCustomerInfoUi = ({
  modalKey,
  title,
  loading,
  fields,
  setFields,
  onSubmit,
}) => {
  const user = useSelector((state) => state.user);

  return (
    <>
      <CustomDialog
        loading={loading}
        err={fields.err}
        onSubmit={onSubmit}
        title={`${title}`}
        closeText="Close"
        confirmText={"Update"}
      >
        {/* <CustomInput
          autoFocus={true}
          // disabled={loading}
          value={fields.customer_name}
          onChange={(e) =>
            setFields({ ...fields, err: "", customer_name: e.target.value })
          }
          type="text"
          label={"Customer Name*"}
        />
        <CustomInput
          // disabled={user.data.role !== USER_ROLES.ADMIN}
          value={fields.box_id}
          onChange={(e) =>
            setFields({ ...fields, err: "", box_id: e.target.value })
          }
          type="text"
          label={" Box Id.*"}
        /> */}
        <Grid2 container spacing={{ md: 2 }} size={12}>
          <Grid2 size={{ md: 4, xl: 4, xs: 12 }}>
            <AsyncDropDown
              key={fields.country}
              // disabled={user.data.role !== USER_ROLES.ADMIN}
              value={fields.country ? { _id: fields.country?._id ? fields?.country?._id : fields?.country, name: fields.country.name ? fields?.country?.name : fields?.countryName } : null}
              lazyFun={async (para) => await getCountryApi({ ...para, allStatus: true })}
              OptionComponent={({ option, ...rest }) => {
                return <ListItem {...rest}>{option.name}</ListItem >
              }}
              onChange={async (changedVal) => {
                setFields((prev) => ({
                  ...prev,
                  country: changedVal?._id || "",
                  countryName: changedVal?.name || "",
                  state: "",
                  stateName: "",
                  city: "",
                  cityName: "",
                }));
              }}
              titleKey={'name'}
              valueKey={"_id"}
              InputComponent={(params) => <CustomInput placeholder={"Select Country"} label={"Country"} {...params} margin="none" />}
            />

          </Grid2>
          <Grid2 size={{ md: 4, xl: 4, xs: 12 }}>
            <AsyncDropDown
              key={fields.country}
              disabled={!fields.country}
              value={fields.country && fields.state ? { _id: fields.state?._id ? fields?.state?._id : fields?.state, name: fields.state.name ? fields?.state?.name : fields?.stateName } : null}
              lazyFun={async (para) => await getStateApi({ ...para, allStatus: true, country: fields.country })}
              OptionComponent={({ option, ...rest }) => {
                return <ListItem {...rest}>{option.name}</ListItem >
              }}
              onChange={async (changedVal) => {
                setFields((prev) => ({
                  ...prev,
                  state: changedVal?._id || "",
                  stateName: changedVal?.name || "",
                  city: "",
                  cityName: "",
                }));
              }}
              titleKey={'name'}
              valueKey={"_id"}
              InputComponent={(params) => <CustomInput placeholder={"Select State"} label={"State"} {...params} margin="none" />}
            />

          </Grid2>
          <Grid2 size={{ md: 4, xl: 4, xs: 12 }}>
            <AsyncDropDown
              key={fields.state}
              disabled={!(fields.country && fields.state)}
              value={fields.country && fields.state && fields.city ? { _id: fields.city?._id ? fields?.city?._id : fields?.city, name: fields.city.name ? fields?.city?.name : fields?.cityName } : null}
              lazyFun={async (para) => await getCityApi({ ...para, allStatus: true, state: fields.state })}
              OptionComponent={({ option, ...rest }) => {
                return <ListItem {...rest}>{option.name}</ListItem >
              }}
              onChange={async (changedVal) => {
                setFields((prev) => ({
                  ...prev,
                  city: changedVal?._id || "",
                  cityName: changedVal?.name || "",
                }));
              }}
              titleKey={'name'}
              valueKey={"_id"}
              InputComponent={(params) => <CustomInput placeholder={"Select City"} label={"City"} {...params} margin="none" />}
            />

          </Grid2>
        </Grid2>
      </CustomDialog>
    </>
  );
};

export default UpdateCustomerInfoUi;
